import { useNavigate } from 'react-router-dom'
import { unitId, actionId } from '@/annotations'
import { LauncherCard } from '@/components/LauncherCard'
import { Chip } from '@/components/Chip'

/**
 * `v-audit` — process/09-SCREEN-SPECS/v-audit.md, Prototype_v2.html `#v-audit` (`div.grid3`, two
 * `card g-green`, one `is-disabled`). **Rebuilt W174**: the previous shape was two bare bordered
 * list items with trailing chevrons — no colour, no icon, no description, and no `Planned` chip on
 * the Bitbucket-native card.
 *
 * **Kept clickable, not `disabled`, unlike the prototype's own `.is-disabled` (`pointer-events:
 * none`)**: this spec's own rule 1 requires "**both cards are navigations carrying `nav.<route
 * id>`**", which the prototype's dead card contradicts — the same class of spec-vs-prototype
 * disagreement this file already reported once (`v-audit` vs `v-setbackup`'s opposite convention
 * on whether a card carries an action id at all). The `Planned` chip is kept as the one part of
 * the prototype's own treatment that doesn't conflict with the spec's rule.
 */
export function VAudit() {
  const navigate = useNavigate()
  return (
    <div data-scr={unitId('v-audit')}>
      <h1 className="m-0 mb-8 text-section font-semibold">Audit logs</h1>
      <div className="grid gap-8" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(330px, 1fr))' }}>
        <LauncherCard
          variant="green"
          icon="i-explore"
          title="Bitbucket Audit Logs"
          badge={<Chip variant="pending">Planned</Chip>}
          description="Bitbucket's native audit log, showing who made each change in your workspace. Not available yet: it is held at your Atlassian organization level and needs a separate grant from an organization administrator, which we do not collect today."
          actionId={actionId('nav.v-auditbb')}
          onClick={() => navigate('/auditbb')}
        />
        <LauncherCard
          variant="green"
          icon="i-shield"
          title="Product Audit Logs"
          description="Review dedicated logs that track all actions you and other admins perform specifically within this application."
          actionId={actionId('nav.v-auditprod')}
          onClick={() => navigate('/auditprod')}
        />
      </div>
    </div>
  )
}
